
























import Vue from 'vue'
import { LocaleOverview, VueI18nExtended } from '@js/interfaces'
import {getCookie, setDomainCookie, deleteCookie} from '@js/libs/cookie-handler'

export default Vue.extend({
  name: 'languageSelector',
  data() {
    return {
      language: {} as LocaleOverview,
      languageToggleOn: false as boolean
    }
  },
  computed: {
    getLocale(): LocaleOverview {
      const locale = this.getLocaleOverviews.find(
        (localeItem: LocaleOverview) => localeItem.locale === this.$i18n.locale
      )

      return locale ? locale : {} as LocaleOverview
    },
    getLocalesMinusSelected(): LocaleOverview[] {
      let locales = this.getLocaleOverviews
      if (this.getLocale !== undefined) {
        locales = this.getLocaleOverviews.filter(
          (locale: LocaleOverview) => locale.locale !== this.getLocale.locale
        )
      }

      return locales
    },
    getLocaleOverviews(): LocaleOverview[] {
      const i18n = this.$i18n as VueI18nExtended
      return i18n.localeOverview as LocaleOverview[]
    },
    getCurrentLanguageIcon(): string {
      return this.getLocale && this.getLocale.icon
        ? `url(${require('@graphics/language_icons/' + this.getLocale.icon)})`
        : 'none'
    }
  },
  methods: {
    setLanguage(language: LocaleOverview): void {
      this.$i18n.locale = language.locale
      setDomainCookie(btoa(language.locale), 'lang', 999999)
    },
    getLanguageIcon(icon: string): string {
      return `url(${require('@graphics/language_icons/' + icon)})`
    },
  }
})
